import { Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {MatChipInputEvent} from "@angular/material/chips";
import {MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";

@Component({
    selector: 'app-chip-box',
    templateUrl: './chip-box.component.html',
    styleUrls: ['./chip-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChipBoxComponent {
  @Input() allChips = [];
  chips: string[] = [];
  separatorKeyCodes: number[] = [ENTER, COMMA];
  filteredChips: Observable<string[]>;
  selectedSkills: number[] = [];

  chipCtrl = new UntypedFormControl();

  @ViewChild('chipInput') chipInput: ElementRef<HTMLInputElement>;

  constructor() {
    this.filteredChips = this.chipCtrl.valueChanges.pipe(
      // even though this appears deprecated, it's only deprecated if you use the scheduler with it which i am not
      startWith(null),
      map((chip: string | null) => (chip ? this._filter(chip) : this.allChips.slice()))
    );
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.chips.push(value);
    }

    // Clear the input value
    event.input.value = '';

    this.chipCtrl.setValue(null);
  }

  remove(chip: string): void {
    const index = this.chips.indexOf(chip);

    if (index >= 0) {
      this.chips.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.chips.push(event.option.viewValue);
    this.chipInput.nativeElement.value = '';
    this.chipCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allChips.filter(chip => chip.toLowerCase().includes(filterValue));
  }
}
